import { Stack } from '@daily/shared/components/Stack';
import { Text } from '@daily/shared/components/Text';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useCallConfig } from '../../hooks/useCallConfig';
import { EmojiSkinTone } from './UserPreferences/EmojiSkinTone';
import { Language } from './UserPreferences/Language';

export const UserPreferences: React.FC = () => {
  const { t } = useTranslation();
  const { enableAdvancedChat, enableEmojiReactions } = useCallConfig();

  return (
    <Stack>
      <Text variant="large">{t('settings.modal.userPreferences')}</Text>
      <Stack gap={20}>
        <Language />
        {(enableAdvancedChat || enableEmojiReactions) && <EmojiSkinTone />}
      </Stack>
    </Stack>
  );
};
